import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=836bb192&scoped=true&"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts&"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=836bb192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836bb192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
